














import { Component, Vue, Prop } from 'vue-property-decorator';
import router from '../router';

interface RouteConfig {
  text: string;
  link: string;
  parent?: string;
}

@Component
export default class TrainingBreadcrumb extends Vue {
  @Prop({ default: '' }) customParent!: string;
  @Prop({ default: '' }) customText!: string;
  @Prop({ default: null }) customAction!: Function | null;

  // Define the training navigation hierarchy
  private routeHierarchy: { [key: string]: RouteConfig } = {
    'trainingcourses': {
      text: 'Training Courses',
      link: '/selectEL',
      parent: undefined // Has a link but shows as if it has a parent
    },
    'trainingmodules': {
      text: 'Training Modules',
      link: '/trainingcourses',
      parent: 'trainingcourses'
    },
    'trainingquiz': {
      text: 'Training Quiz',
      link: '/trainingquiz',
      parent: 'trainingmodules'
    },
    'trainingvideo': {
      text: 'Training Video',
      link: '/trainingvideo',
      parent: 'trainingmodules'
    }
  };

  get currentRouteName(): string {
    return this.$route.name || '';
  }

  get iconColorClass(): string {
    // Red icon for trainingcourses page
    if (this.currentRouteName === 'trainingcourses') {
      return 'primary-color';
    }
    // Blue icon for all other training pages
    return 'blue-color';
  }

  get headingColorClass(): string {
    // White text for trainingcourses page (default from global styles)
    if (this.currentRouteName === 'trainingcourses') {
      return '';
    }
    // Blue text for all other training pages
    return 'blue-heading';
  }

  get isHeadingStyle(): boolean {
    // Use heading style only on trainingcourses page
    return this.currentRouteName === 'trainingcourses';
  }

  get highlightText(): string {
    if (this.currentRouteName === 'trainingcourses') {
      return 'Training';
    }
    return '';
  }

  get remainingText(): string {
    if (this.currentRouteName === 'trainingcourses') {
      return 'Courses';
    }
    return '';
  }

  get breadcrumbText(): string {
    // If custom text is provided, use it
    if (this.customText) {
      return this.customText;
    }

    // Special case for trainingcourses - always show "Training Courses"
    if (this.currentRouteName === 'trainingcourses') {
      return 'Training Courses';
    }

    // Otherwise, get from hierarchy
    const parentRoute = this.getParentRoute();
    return parentRoute ? parentRoute.text : '';
  }

  get breadcrumbLink(): string {
    // If custom parent is provided, use it
    if (this.customParent) {
      return this.customParent;
    }

    // Special case for trainingcourses - link to selectEL
    if (this.currentRouteName === 'trainingcourses') {
      return '/selectEL';
    }

    // Otherwise, get from hierarchy
    const parentRoute = this.getParentRoute();
    return parentRoute ? parentRoute.link : '#';
  }

  getParentRoute(): RouteConfig | null {
    const currentRoute = this.routeHierarchy[this.currentRouteName];
    
    if (!currentRoute || !currentRoute.parent) {
      return null; // No parent to show
    }

    const parentRouteName = currentRoute.parent;
    const parentRoute = this.routeHierarchy[parentRouteName];

    return parentRoute || null;
  }

  navigateBack(): void {
    // If custom action is provided, use it
    if (this.customAction) {
      this.customAction();
      return;
    }

    // Otherwise, use router navigation
    if (this.breadcrumbLink && this.breadcrumbLink !== '#') {
      router.push(this.breadcrumbLink);
    }
  }
}
